import {FC, ReactNode} from "react";
import IconLinkArrow from "../../../../assets/icons/link-arrow-right-up-blue.svg";

interface IProps {
  icon: string;
  label: string;
  onClick: () => void;
}

export const ChartEntryButton: FC<IProps> = ({icon, label, onClick}) => (
  <div
    role="button"
    tabIndex={0}
    style={{
      color: "#fff",
      backgroundColor: "#22272B",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      padding: "10px 12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      gap: "10px",
      flex: 1,
      minWidth: 0,
      width: "100%",
      cursor: "pointer",
    }}
    onClick={onClick}
    onKeyDown={(event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClick();
      }
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
        flex: 1,
        minWidth: 0,
      }}
    >
      <img src={icon} alt="" style={{flexShrink: 0, marginTop: 2}} />
      <span style={{minWidth: 0}}>{label}</span>
    </div>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        color: "#56B3FF",
        flexShrink: 0,
        whiteSpace: "nowrap",
      }}
    >
      <span>Открыть</span>
      <img src={IconLinkArrow} alt="" />
    </div>
  </div>
);

export const ChartEntryButtonsRow: FC<{children: ReactNode}> = ({children}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      gap: "12px",
      width: "100%",
    }}
  >
    {children}
  </div>
);

/** @deprecated use ChartEntryButtonsRow */
export const GartnerChartsStack = ChartEntryButtonsRow;
